import Head from "next/head";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Slider from "react-slick";
import config from "../../../config";
import { ImageList } from "../../../src/components/design-pages/imageList";

const tileData = [
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Classy simple kitchen design with textured grey tiles.webp",
    alt: "Modern simple kitchen design with a copper sink and geometric backsplash",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Modern simple kitchen design with countertop.webp",
    alt: "Functional simple kitchen design featuring a checkered tile wall",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Modern simple kitchen design with fruit themed.webp",
    alt: "Contemporary simple kitchen design with a blend of neutral tones",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Simple kitchen design paired with neutral-toned cabinetry.webp",
    alt: "Simple Kitchen design with a matte finish cabinets",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Simple kitchen design with abstract patterned tiles.webp",
    alt: "Elegant simple kitchen design setup with silver sink",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Simple Kitchen design with a matte finish cabinets.webp",
    alt: "Classy simple kitchen design with textured grey tiles and wooden cabintery",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Simple kitchen design with black countertop.webp",
    alt: "Stylish ivory tiles for simple kitchen design, contrasted with dark cabinetry",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/simple kitchen design with brick tiles.webp",
    alt: "Contemporary simple kitchen design with white and abstract patterns",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Simple kitchen design with brown and creama tiles.webp",
    alt: "Simple kitchen design with marble brown and creama tiles",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/simple kitchen design with checkered wall tiles.webp",
    alt: "Modern simple kitchen design showcasing polished worktop",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Simple kitchen design with floral pattern wall.webp",
    alt: "Stylish countertop setup for modern simple kitchen design",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Simple kitchen design with fruit themed tiles.webp",
    alt: "Minimalist simple kitchen design with in-built stove and Oven",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Simple kitchen design with geometric tiles.webp",
    alt: "Sleek and simple kitchen design with light tone cabinetry and countertops",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Simple kitchen design with in-built stove.webp",
    alt: "Simple kitchen design with floral pattern wall and inbuilt stove",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Simple kitchen design with marble grey tiles.webp",
    alt: "Golden tea set pattern wall tile for simple kitchen design",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Simple kitchen design with matte black hardware.webp",
    alt: "Sophisticated simple kitchen design with wooden flooring",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Simple kitchen design with multi-colored patterned tiles.webp",
    alt: "Simple kitchen design featuring with multi-colored patterned tiles",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Simple kitchen design with neutral tones.webp",
    alt: "Simple kitchen design with artistic patterned tiles combined with white cabinets",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Simple kitchen design with polished worktop.webp",
    alt: "Eye catching simple kitchen design with marble grey tiles",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Simple kitchen design with silver sink.webp",
    alt: "White brick tiles with wooden countertops for simple kitchen design",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Simple kitchen design with white cabinets.webp",
    alt: "Simple kitchen design with fruit-themed 3D tiles",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Simple kitchen design with wooden flooring.webp",
    alt: "Simple kitchen design paired with neutral-toned cabinetry and fruit inspired backsplash",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Simple kitchen with geometric backsplash tiles.webp",
    alt: "Modern simple kitchen design with fruit themed cambine with dark-colored cabinets",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Sleek and simple kitchen design with cabinetry.webp",
    alt: "Eye catching simple kitchen design with hexagonal geometric tiles",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Small indoor plants featuring simple kitchen design.webp",
    alt: "Simple kitchen design paired with matte black hardware and fixtures",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Stylish ivory tiles for simple kitchen design.webp",
    alt: "Pendant lights and small potted plants elegant idea for simple kitchen design",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Tea set pattern wall tile for simple kitchen design.webp",
    alt: "Simple kitchen design paired with black countertop",
  },
  {
    src: "https://images.orientbell.com/media/design-images/kitchen/Simple kitchen/Travertine mosaic tiles for simple kitchen design.webp",
    alt: "Travertine mosaic tiles with wooden cabinetry for simple kitchen design",
  },
];

const settings = {
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  centerMode: false,
  autoplaySpeed: 3000,
  arrows: true,
  dots: false,
  centerPadding: "0px",
  responsive: [
    {
      breakpoint: 991,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 641,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 1,
      },
    },
  ],
};
const faqs = [
  // Removed as per clients request
  // {
  //   question: "How to design a small kitchen on a budget?",
  //   answer:
  //     "To design a small kitchen on a budget, you should focus on installing space-saving storage solutions. Combine affordable materials like tiles for working zones. Pick anti-skid options for flooring. Also, go for subtle hues for a minimalist and elegant cooking area.",
  // },
  {
    question: "What are the basic layouts for a simple kitchen?",
    answer:
      "The basic layouts for simple kitchens are L-shaped for efficient flow and U-shaped for ample storage and counter space. Also, you can consider single-wall and gallery kitchen layouts. ",
  },
  {
    question: "What materials are best for a simple kitchen?",
    answer:
      "For simple culinary areas, you should choose long-lasting, affordable materials like tiles for walls, countertops, and floors and MDF for cabinets. Also, go for easy-care stainless steel appliances. Besides, ensure sticking to neutral shades and minimalist designs for a clean, evergreen appeal. ",
  },
  {
    question:
      "Which is a better design for your culinary space - modular or non-modular?",
    answer:
      "A modular kitchen offers better space usage and easy installation with durable elements. However, a non-modular kitchen can be more budget-friendly and offer flexibility in design. So, go with any of these options that suit your needs the most! ",
  },
];
const text = `Simple kitchen designs are quite a popular choice for many homes these days. They offer minimalism and easy functionality. Since not everyone has a large house with a spacious kitchen, non-modular kitchen designs are perfect for small homes. Even low-cost simple kitchen designs can still be stylish and efficient without using too many costly premium elements. To craft a modern simple kitchen design, you should focus on clean lines, less clutter, and practicality. After all, the key is to keep the kitchen’s interior design simple. No need to have a fancy layout for a beautiful culinary space. So, keep your focus on infusing low-cost tiles, durable countertops, and fixtures to design long-term kitchen decor. Here are some simple kitchen design ideas to create a functional, welcoming culinary space. `;

export default function SimpleKitchenDesings() {
  const router = useRouter();
  const [isExpertTalkClicked, setIsExpertTalkClicked] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [relatedBlogData, setRelatedBlogData] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [isReadMore, setIsReadMore] = useState(false);

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  var requestOptions = {
    method: "GET",
  };
  const getRelatedBlogs = async () => {
    // try{

    fetch(
      `${config.HEADLESS_BASE_URL}/blog/wp-json/post/v2/category/term=kitchen-designs`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        setRelatedBlogData(JSON.parse(result));
      })
      .catch((error) => console.log("error", error));
  };

  useEffect(() => {
    getRelatedBlogs();
  }, []);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const displayedFAQs = showAll ? faqs : faqs.slice(0, 5);

  const maxChars = 300;
  const previewText = text.substring(0, maxChars);
  const remainingText = text.substring(maxChars);
  return (
    <>
      <Head>
        <title>
          Simple Kitchen Design Ideas for a Clean and Modern Look | Orientbell
        </title>

        <meta
          name="title"
          content="Simple Kitchen Design Ideas for a Clean and Modern Look | Orientbell"
        />
        <meta
          name="description"
          content="Discover Simple Kitchen Design ideas at Orientbell. Explore clean and minimalist layouts that combine functionality with elegance for a modern, clutter-free space. Get inspired today!"
        />
      </Head>

      <div className="designpage-section">
        <div className="container">
          <Breadcrumb>
            <Breadcrumb.Item href="www.orientbell.com">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="https://www.orientbell.com/design-ideas">
              Design Ideas
            </Breadcrumb.Item>
            <Breadcrumb.Item href="www.orientbell.com/design-ideas/kitchen-designs">
              Kitchen Designs
            </Breadcrumb.Item>
            <Breadcrumb.Item href="www.orientbell.com/desgn-ideas/kitchen-designs/simple-kitchen">
              Simple Kitchen
            </Breadcrumb.Item>
          </Breadcrumb>
          <div className="designpage-heading-bx padding-spacing">
            <h4>Showing {tileData.length} results for </h4>
            <h1>Simple Kitchen Design</h1>
            <p className="description-text">
              {previewText}
              {!isReadMore && text.length > maxChars && "..."}
              {isReadMore && <span>{remainingText}</span>}
              {text.length > maxChars && (
                <button onClick={toggleReadMore}>
                  {isReadMore ? "Read Less" : "Read More"}
                </button>
              )}
            </p>
          </div>
          <div className="obl-master-design-section">
            <h2>Simple Kitchen Gallery</h2>
            <div className="designpage-category-row inner-design-gallery">
              <ImageList tileData={tileData} />
            </div>

            <div className="bottom-content">

            <iframe width="560" height="315" src="https://www.youtube.com/embed/3oMTO_ACO2k?si=s4eW86DR4P2z19vU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              <div className="common-text-content-section">
                <h2>Indian Style Simple Kitchen Design</h2>
                <p>
                  Simple Indian-style kitchen designs are all about simplicity,
                  comfort, and blending tradition with modern touches. Here are
                  some ideas that you can consider to craft such a beautiful and
                  simple Indian kitchen design.
                </p>
                <ul>
                  <li>
                    <h3>
                      <strong>Functionality: </strong>
                    </h3>
                    <p>
                      Every simple kitchen design focuses on space utilisation.
                      Place your utensils and appliances in a way that makes
                      cooking and preparation easier. Also, consider smart
                      placement of cabinets and counters to save space and time.
                    </p>
                  </li>
                  <li>
                    <h3>
                      <strong>Traditional Tile Designs: </strong>
                    </h3>
                    <p>
                      Install tiles in vibrant colours and busy patterns to add
                      a traditional touch while reflecting Indian culture. Go
                      for options like floral and geometric for a stunning
                      backsplash. Pick granalt or
                      <a href="/tiles/slab-tiles">slab tiles</a>
                      for a long-lasting countertop. Select a matte or anti-skid
                      option like terracotta to move around safely in the
                      cooking area.
                    </p>
                  </li>
                  <li>
                    <h3>
                      <strong>Space and Layout: </strong>
                    </h3>
                    <p>
                      Pick a well-planned layout for your simple Indian kitchen
                      to ensure a balance between work areas and storage. Also,
                      make sure that the design lets you move easily while
                      cooking.
                    </p>
                  </li>
                  <li>
                    <h3>
                      <strong>Renovation with Style: </strong>
                    </h3>
                    <p>
                      Whether you are upgrading or starting fresh, your culinary
                      space should reflect your idealistic personality. Simple
                      kitchens encourage a minimalist yet warm feel. After all,
                      minimalist designs are in trend because of their function
                      and stylishness.
                    </p>{" "}
                  </li>
                </ul>
              </div>

              <div className="common-text-content-section">
                <h2> Benefits of Simple Kitchen Design</h2>
                <p>
                  A simple kitchen design offers so many advantages. Here are
                  some benefits to explore.
                </p>
                <ul>
                  <li>
                    <h3>
                      <strong>Space Utilisation: </strong>
                    </h3>
                    <p>
                      Every simple kitchen design maximises space utilisation
                      with clean lines and clever storage options. Also, do you
                      need more counter space? Install floating shelves and
                      wall-mounted cabinets to store items.
                    </p>
                  </li>
                  <li>
                    <h3>
                      <strong>Stylish Yet Practical: </strong>
                    </h3>

                    <p>
                      Pick glossy tiles for the backsplash that needs minimal
                      upkeep. Go for elegant patterns to add visual interest and
                      style. Select matte or
                      <a href="/tiles/anti-skid-tiles"> anti-skid tiles </a>
                      to offer safe flooring.
                    </p>
                  </li>
                  <li>
                    <h3>
                      <strong>Timeless Appeal:</strong>
                    </h3>
                    <p>
                      Design a beautiful kitchen concept that sticks to
                      simplicity while staying fresh over time. Follow the
                      newest trends of minimalism to create a culinary space
                      that matches every taste and never goes out of style.
                    </p>{" "}
                  </li>

                  <li>
                    <h3>
                      <strong>Easy to Maintain:</strong>
                    </h3>
                    <p>
                      Try to keep fewer units and install low-maintenance
                      granalt tiles on durable worktops. Focus on crafting a
                      kitchen that needs less effort to remain neat.
                    </p>
                  </li>

                  <li>
                    <h3>
                      <strong>Affordable: </strong>
                    </h3>
                    <p>
                      Focus on the essentials to cut down the overall cost. You
                      can choose long-lasting materials like quality tiles that
                      can last without being too costly.
                    </p>
                  </li>
                </ul>
              </div>

              <div className="common-text-content-section">
                <h2>Tips For Maintaining a Simple Kitchen Design</h2>
                <p>
                  To maintain a simple kitchen interior design, here are some
                  easy tips.
                </p>
                <ul>
                  <li>
                    <h3>
                      <strong> Keep It Tidy: </strong>
                    </h3>
                    <p>
                      Regularly clean all surfaces. Wipe down your backsplash,
                      countertop, stovetop, and floor daily to remove oil and
                      stain buildup.{" "}
                    </p>
                  </li>
                  <li>
                    <h3>
                      <strong> Organise Smartly: </strong>
                    </h3>
                    <p>
                      Arrange all items neatly so that every element stays in
                      its place. Add storage solutions like baskets to keep
                      clutter away.
                    </p>
                  </li>
                  <li>
                    <h3>
                      <strong>Embrace Simple Decor: </strong>
                    </h3>
                    <p>
                      Select a simple normal{" "}
                      <a href="https://www.orientbell.com/design-ideas/kitchen-designs">
                        kitchen design{" "}
                      </a>
                      with a minimalist style with tiles in soft shades and
                      subtle tile accents.
                    </p>{" "}
                  </li>

                  <li>
                    <h3>
                      <strong>Maintain the Tiles: </strong>
                    </h3>
                    <p>
                      Install
                      <a href="/tiles/glossy-tiles">glossy tiles</a>
                      on the walls, backsplash, and countertop for easy-care
                      work surfaces. Pick a matte or anti-skid option in large
                      sizes for the flooring. Fewer grout lines make the floor
                      upkeep easier. Also, clean the tile surfaces regularly to
                      keep the decor look fresh.
                    </p>
                  </li>

                  <li>
                    <h3>
                      <strong>Maximise Space: </strong>
                    </h3>
                    <p>
                      Try to keep your countertop clear. Use space wisely to
                      prevent mess and have more room for meal preparation.
                    </p>
                  </li>
                </ul>
              </div>
            </div>

            <div className="designpage-faq-section padding-spacing">
              <h2>FAQs About Simple Kitchen Design</h2>
              <div className="newacd designpage-faq-row">
                <ul className="accordion">
                  {displayedFAQs.map((faq, index) => (
                    <li key={index}>
                      <a className="toggle" onClick={() => handleToggle(index)}>
                        {index + 1}. {faq.question}
                      </a>
                      {activeIndex === index && (
                        <ul className="inner">
                          <li>{faq.answer}</li>
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
                {faqs.length > 5 && (
                  <div className="tru_btn_new design-page">
                    <button
                      className="btn btn-primary"
                      onClick={() => setShowAll(!showAll)}
                    >
                      {showAll ? "Show Less" : "Read More"}
                    </button>
                  </div>
                )}
              </div>
            </div>

            {relatedBlogData?.length > 0 && (
              <div className="tile-related-blog">
                <h2 className="title">Related Blogs</h2>
                <div className="designpage-relatedpost-row">
                  <Slider {...settings}>
                    {relatedBlogData?.map((obj, index) => {
                      return (
                        <div className="related-blog-col" key={index}>
                          <div className="blog-figure">
                            <a href={obj.permalink}>
                              <img
                                src={obj.image}
                                loading="lazy"
                                alt="Marble Tiles Vs Marble Slab: What is Better for Your Home?"
                              />
                            </a>
                          </div>
                          <div className="blog-text">
                            <div className="listingDate">{obj.date}</div>
                            <div className="listingHead">
                              <a href={obj.permalink}>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: obj.title,
                                  }}
                                />
                              </a>
                            </div>
                            <div className="listingText">
                              <p>
                                {" "}
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: obj.content.slice(0, -11),
                                  }}
                                />
                              </p>
                              <div className="listingButton">
                                <a href={obj.permalink}>Read More</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
